const subscription = async (email) => {
  const apiKey = process.env.FLODESK_API;

  const response = await fetch('https://api.flodesk.com/v1/subscribers', {
    method: 'POST',
    headers: {
      'User-Agent': 'wavesforwater (https://www.wavesforwater.org)',
      // eslint-disable-next-line
      'Authorization': `Basic ${apiKey}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  })
    .then(resp => resp.json())
    .then(data => fetch(`https://api.flodesk.com/v1/subscribers/${data.id}/segments`, {
      method: 'POST',
      headers: {
        'User-Agent': 'wavesforwater (https://www.wavesforwater.org)',
        // eslint-disable-next-line
        'Authorization': `Basic ${apiKey}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        segment_ids: ['653d78a0542f80d1a15e765a'],
      }),
    }))
    // eslint-disable-next-line no-return-await
    .then(async res => await res.json());

  try {
    const data = await response;

    return data;
  } catch (error) {
    console.error('Subscribe error:', error);
  }
};

export default subscription;
